import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Injectable } from "@angular/core";
import { CommonService } from "../../../shared/services/common.service";
import { lastValueFrom, Observable } from "rxjs";
import { Store } from "@ngrx/store";
import * as fromRoot from "../../../../state/app.state";
import { HttpClient } from "@angular/common/http";
import { v1URL } from "../../../shared/constants/urls.constants";
import { drillDownUrls } from "../../../shared/core/shared.selectors";
import { SetDrillDownUrls } from "../../../shared/core/shared.actions";

@Injectable({
  providedIn: 'root'
})
export class SuperAdminGuard {
  constructor(
    private store: Store<fromRoot.State>,
    private router: Router,
    private commonService: CommonService,
    private http?: HttpClient,
  ) {
  }

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree> {


    this.commonService.requestedResourceId.next([])

    return true;
  }
}
